import posthog from "posthog-js";

let initialized = false;

export const initAnalytics = () => {
  const token = import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN;
  if (!token || initialized) return false;

  posthog.init(token, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    defaults: "2026-01-30",
    capture_pageview: false,
    autocapture: {
      css_selector_allowlist: ["button", "a", "[data-analytics]"],
    },
    mask_all_text: true,
    mask_all_element_attributes: true,
    persistence: "localStorage+cookie",
  });

  initialized = true;
  return true;
};

export const getAnalyticsClient = () => posthog;

export const identifyAnalyticsUser = (id: string, properties?: Record<string, unknown>) => {
  if (!initialized) return;
  posthog.identify(id, properties);
};

export const resetAnalyticsUser = () => {
  if (!initialized) return;
  posthog.reset();
};

export const captureAnalyticsEvent = (event: string, properties?: Record<string, unknown>) => {
  if (!initialized) return;
  posthog.capture(event, properties);
};

export const identifyFutureStackUser = (userId: string, properties?: Record<string, unknown>) => {
  if (!initialized) return;
  posthog.people.set(properties || {});
};
